import React, {useEffect, useMemo, useState} from "react";
import {Accordion, Col, Modal, Row, Spinner, Card, Badge} from "react-bootstrap";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {
    getCurrentUser, getDefaultOptionByValue,
    getGreekCurrencyFormat, getOptionsByData, getRecordTypeOptions, getSubaccountOptions,
    isEmpty,
    quickClone
} from "../../../../_helpers/commonFunctions";
import Dropdown from "../../../primer/Dropdown";
import {registerOrSortToOptionsDD} from "../Cloud/Components/constants";
import Button from "react-bootstrap/Button";
import {getMyDataRowTypes} from "../../../../_helpers/sharedmydata";
import EditableTable from "../../../primer/Editable-Table";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {allInvoiceTypesData, salesInvoiceTypesData} from "../../../../_data/mydata/salesInvoiceTypes";
import {MdOutlineSyncProblem} from "react-icons/md";
import {IoCheckmarkDoneCircleSharp} from "react-icons/io5";
import moment from "moment";
import DemoVectorSearchModal from "./demoVectorSearchModal";
import {setAISettings} from "../../../../_reducers/aiSlice";
import AICreditsUsage from "../AI/components/aiCreditsUsage";
import {
    fetchAccountingAdvancedTypes,
    fetchAccountingRecordCategories, fetchAccountingRecordSubcategories,
    fetchAdvancedTypes,
    fetchAdvancedTypesBuys,
    fetchAdvancedTypesSales, fetchBankAccounts, fetchBankingSettings,
    fetchCompanyDetails
} from "../../../../_apis/api";
import {Popover} from "antd";
import StatusSlider from "../../../primer/StatusSlider/StatusSlider";
import {vatDeductibleToleranceLabels} from "../AI/aiHelper";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import {useTranslation} from "../../../../hooks/useTranslation";
import Input from "../../../common/Input";

const AISettings = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const user = getCurrentUser();
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    //const buysGeneralSettings = useSelector((state) => state.BUYS_SETTINGS.buysGeneralSettings);
    const activityOptions = companyDetails?.activitiesArray ? companyDetails?.activitiesArray.map((o) => {
        return {
            label: o.activityName,
            value: o.activityName,
        }
    }) : [];
    const defaultSettings = {
        // Cloud
        enableCloudAI: false,
        batchAI: false,
        unshortedFolders: [],
        documentTypeMapping: [],
        installationActivities: [],
        myDataReportClearance: false,
        myDataReportSalesClearance: false,
        myDataReportBuysClearance: false,
        myDataReportClearanceDates: [],
        companyVehiclesCheck: false,
        analyticProductsInBuys: true,
        vatDeductibleTolerance: 3, // Strictness from 1-5 descending

        // Banking
        enableBankingAI: false,
        enableBankingBatchAI: false,
        aiTransactionsClearance: false,
        aiTransactionsClearanceDates: [],

        // Payroll Configuration
        payrollConfiguration: {
            category: "",
            categoryName: "",
            subCategory: "",
            subCategoryName: "",
            documentType: "",
            documentTypeName: "",
            recordType: "normal",
            accounts: []
        },

        // Batch Settlements
        batchSettlementsDefaultCP: "",
        batchSettlementsDefaultCPName: "",
        batchSettlementsDefaultCPPreNumber: "",
        batchSettlementsDefaultCPReturn: "",
        batchSettlementsDefaultCPReturnName: "",
        batchSettlementsDefaultCPReturnPreNumber: "",

        // Prepaid Statements
        prepaidStatementsDefaultSP: "",
        prepaidStatementsDefaultSPName: "",
        prepaidStatementsDefaultSPPreNumber: "",
        prepaidStatementsDefaultSPReturn: "",
        prepaidStatementsDefaultSPReturnName: "",
        prepaidStatementsDefaultSPReturnPreNumber: "",
        prepaidStatementsDefaultPaymentType: "",
        prepaidStatementsPrepaidBucketAccount: "",
        prepaidStatementsPrepaidCardAccount: "",
        prepaidStatementsCreditBucketAccount: "",
        prepaidStatementsCreditCardAccount: "",

        prepaidStatementsAccountingCategory: "",
        prepaidStatementsAccountingSubCategory: "",
        prepaidStatementsAccountingRecordType: "",
        prepaidStatementsAccountingDocumentType: "",
    }
    const initDocumentTypeMapping = {
        rowType: "income", // income / expense
        myDataType: "",
        documentType: "",
        documentTypeSection: "",
    }
    const initInstallationActivities = {
        installationMasterId: "",
        activity: [],
        vatRegime0: false,
        assetIdentification: false,
        assetLowerLimit: 0,
        anamorfosis: false,
        anamorfosisPercentForRent: 0,
        anamorfosisPercentForDEKO: 0
    }
    const initMyDataReportClearance = {
        dayOfTheMonth: 5,
        backwardTravel: "lastMonth",
    }
    const initTransactionClearance = {
        dayOfTheMonth: 5,
        backwardTravelMonthFrom: "2",
        backwardTravelMonthTo: "1",
        bankAccounts: []
    }
    const {t} = useTranslation();
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
    const bankData = bankAccounts.filter((bankAccount) => bankAccount.isActive === "active");
    const bankOptions = bankData.map((item) => ({value: item._id, label: `${item.name} - ${item.iban}`}));
    const [settings, setSettings] = useState(quickClone({...defaultSettings, ...aiSettings}));
    const [incrKey1, setIncrKey1] = useState(0);
    const [incrKey2, setIncrKey2] = useState(0);
    const [incrKey3, setIncrKey3] = useState(0);
    const [incrKey4, setIncrKey4] = useState(0);
    const [incrKey5, setIncrKey5] = useState(0);
    const [loadingSave, setLoadingSave] = useState(false);
    const installationOptions = useInstallationOptions(false);
    const [showSyncProductsModal, setShowSyncProductsModal] = useState(false);
    const [showSyncBankModal, setShowSyncBankModal] = useState(false);
    const [syncDataLoader, setSyncDataLoader] = useState(false);
    const [syncLoader, setSyncLoader] = useState(false);
    const [runCronJobLoader, setRunCronJobLoader] = useState(false);
    const [runTransactionsCronJobLoader, setRunTransactionsCronJobLoader] = useState(false);
    const [syncData, setSyncData] = useState(null);
    const [showDemoVectorModal, setShowDemoVectorModal] = useState(false);
    const [showResetAISettings, setShowResetAISettings] = useState(false);
    const [creditsUsageData, setCreditsUsageData] = useState(null);
    const [showBuyCreditsModal, setShowBuyCreditsModal] = useState(false);
    const [selectedCreditAmount, setSelectedCreditAmount] = useState(500);
    const [buyLoading, setBuyLoading] = useState(false);
    const [orderData, setOrderData] = useState(null);
    const [primerCredentials, setPrimerCredentials] = useState(null);
    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const [syncOrderLoading, setSyncOrderLoading] = useState(false);
    const [primaryCounter, setPrimaryCounter] = useState(null);

    const ACCOUNTING_DATA = useSelector((state) => state.ACCOUNTING_DATA);
    const [accounts, setAccounts] = useState([]);
    const categories = [{ label: "Κενό", value: ""}, ...getOptionsByData(ACCOUNTING_DATA.accountingRecordCategories, "_id", "name")]
    const subCategories = [{ label: "Κενό", value: ""}, ...getOptionsByData(ACCOUNTING_DATA.accountingRecordSubcategories, "_id", "name")]
    const documentTypesOptions = useMemo(() => getOptionsByData(ACCOUNTING_DATA.accountingAdvancedTypes, "_id", "name"), [ACCOUNTING_DATA.accountingAdvancedTypes]);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);

    const clientPaymentOptions = [
        {label: "Κενό", value: ""},
        ...advancedTypes.filter((el) => el.section === "Client Payments").map((el) => ({value: el._id, label: el.name}))
    ]

    const supplierPaymentsOptions = [
        {label: "Κενό", value: ""},
        ...advancedTypes.filter((el) => el.section === "Supplier Payments").map((el) => ({value: el._id, label: el.name}))
    ]

    //const buysPaymentTypes = (buysGeneralSettings.paymentTypes?.filter((el) => !["cheque", "credit"].includes(el.type)) || []).map((o) => ({value: o._id, label: o.name}));

    const creditPackagesOptions = [
        { label: "500 Credits", value: 500 },
        { label: "700 Credits", value: 700 },
        { label: "1.000 Credits", value: 1000 },
        { label: "2.000 Credits", value: 2000 },
        { label: "5.000 Credits", value: 5000 },
        { label: "10.000 Credits", value: 10000 },
        { label: "20.000 Credits", value: 20000 },
        { label: "30.000 Credits", value: 30000 },
    ];

    const creditPackagePrices = {
        500: 7,
        700: 10,
        1000: 13,
        2000: 25,
        5000: 50,
        10000: 100,
        20000: 200,
        30000: 300
    };

    useEffect(() => {
        dispatch(fetchBankAccounts({ company: company.id }));
        dispatch(fetchAdvancedTypes({company: company.id}));
        dispatch(fetchAdvancedTypesSales({company: company.id}));
        dispatch(fetchAdvancedTypesBuys({company: company.id}));
        dispatch(fetchAccountingRecordCategories(company.id));
        dispatch(fetchAccountingRecordSubcategories(company.id));
        dispatch(fetchAccountingAdvancedTypes(company.id));
        fetchOrderData();
        fetchPrimerCredentials();
        loadAccounts(null, setAccounts);
    }, [])

    useEffect(() => {
        if (companyDetails?.primaryCompany) {
            fetchPrimaryCompanyCounter();
        }
    }, [companyDetails?.primaryCompany])

    useEffect(() => {
        if (settings.documentTypeMapping) setIncrKey1(incrKey1 + 1);
    }, [settings?.documentTypeMapping])

    useEffect(() => {
        if (settings.installationActivities) setIncrKey2(incrKey2 + 1);
    }, [settings?.installationActivities])

    useEffect(() => {
        if (settings?.myDataReportClearanceDates) setIncrKey3(incrKey3 + 1);
    }, [settings?.myDataReportClearanceDates])

    useEffect(() => {
        if (settings?.aiTransactionsClearanceDates) setIncrKey4(incrKey4 + 1);
    }, [settings?.aiTransactionsClearanceDates, bankAccounts])

    useEffect(() => {
        if (settings?.payrollConfiguration) setIncrKey5(incrKey5 + 1);
    }, [settings?.payrollConfiguration, accounts])

    useEffect(() => {
        let intervalId;
        if (showSyncProductsModal || showSyncBankModal) {
            fetchSyncData();
            intervalId = setInterval(() => fetchSyncData(false), 1000);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [showSyncProductsModal, showSyncBankModal]);

    const fetchSyncData = (withLoader = true) => {
        if(withLoader) setSyncDataLoader(true)
        axios.get(`${process.env.REACT_APP_API_URL2}/ai/sync-status`, {
            headers: { "Content-Type": "application/json" },
            params: {company: company.id}
        }).then((res) => {
            if (res.data.status === "200") {
                setSyncData(res.data.data);
            } else {
                setSyncData(null);
                toast.error("Κάτι πήγε στραβά!");
            }
            setSyncDataLoader(false);
        }).catch((err) => {
            setSyncDataLoader(false);
            setSyncData(null);
            toast.error("Κάτι πήγε στραβά!");
            console.log(err);
        })
    }

    const syncProductDataNow = () => {
        setSyncLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/sync-product-vector-data`, {company: company.id}).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η διαδικασία συγχρονισμού ξεκίνησε.");
            } else {
                toast.error(res.data.message);
            }
            setSyncLoader(false);
        }).catch((err) => {
            setSyncLoader(false);
            console.log(err);
            toast.error("Κάτι πήγε στραβά!");
        })
    }

    const syncBankDataNow = () => {
        setSyncLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/sync-bank-vector-data`, {company: company.id}).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η διαδικασία συγχρονισμού ξεκίνησε.");
            } else {
                toast.error(res.data.message);
            }
            setSyncLoader(false);
        }).catch((err) => {
            setSyncLoader(false);
            console.log(err);
            toast.error("Κάτι πήγε στραβά!");
        })
    }

    const runMrCronJob = () => {
        setRunCronJobLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/mr-run-company-clearance`, {company: company.id}).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η διαδικασία διασταύρωσης ξεκίνησε.");
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
            setRunCronJobLoader(false);
        }).catch((err) => {
            setRunCronJobLoader(false);
            console.log(err);
            toast.error("Κάτι πήγε στραβά!");
        })
    }

    const runTransactionsCronJob = () => {
        setRunTransactionsCronJobLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/transactions-run-company-clearance`, {company: company.id}).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η διαδικασία επεξεργασίας συναλλαγών ξεκίνησε.");
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
            setRunTransactionsCronJobLoader(false);
        }).catch((err) => {
            setRunTransactionsCronJobLoader(false);
            console.log(err);
            toast.error("Κάτι πήγε στραβά!");
        })
    }

    const fetchOrderData = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/ai/credits-order-data`, {
            headers: { "Content-Type": "application/json" },
            params: { company: company.id }
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data) {
                    setOrderData(res.data.data);
                } else {
                    setOrderData(null);
                }
            } else {
                toast.error(res.data.message || "Σφάλμα κατά την ανάκτηση της παραγγελίας.");
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const saveSettings = (resetDefault = false) => {
        // Quick validations
        if (settings.installationActivities.some((el) => isEmpty(el.installationMasterId) || isEmpty(el.activity))) {
            return toast.error("Παρακαλώ συμπληρώστε όλες τις αντιστοιχίες εγκαταστάσεων - δραστηριοτήτων.");
        } else if (settings.documentTypeMapping.some((el) => isEmpty(el.rowType) || isEmpty(el.myDataType) || isEmpty(el.documentType))) {
            return toast.error("Παρακαλώ συμπληρώστε όλες τις αντιστοιχίες τύπων.");
        } else if (settings.myDataReportClearanceDates.some((el) => isNaN(+el.dayOfTheMonth) || +el.dayOfTheMonth < 1 || +el.dayOfTheMonth > 31 || isEmpty(el.backwardTravel))) {
            return toast.error("Παρακαλώ συμπληρώστε με έγκυρα πεδία όλες τις ρυθμίσεις διασταύρωσης με MyData Vision.");
        } else if (settings.aiTransactionsClearanceDates.some((el) =>
            isNaN(+el.dayOfTheMonth) ||
            +el.dayOfTheMonth < 1 ||
            +el.dayOfTheMonth > 31 ||
            isEmpty(el.backwardTravelMonthFrom) ||
            isEmpty(el.backwardTravelMonthTo) ||
            Number(el.backwardTravelMonthFrom) <= Number(el.backwardTravelMonthTo) ||
            el.bankAccounts?.length === 0
        )) {
            return toast.error("Παρακαλώ συμπληρώστε με έγκυρα πεδία όλες τις ρυθμίσεις αυτόματης εκτέλεσης συναλλαγών.");
        }
        //payroll validations
        if ((!isEmpty(settings?.payrollConfiguration?.category) || !isEmpty(settings?.payrollConfiguration?.subCategory) || !isEmpty(settings?.payrollConfiguration?.documentType)) &&
            (isEmpty(settings?.payrollConfiguration?.category) || isEmpty(settings?.payrollConfiguration?.subCategory) || isEmpty(settings?.payrollConfiguration?.documentType))) {
            return toast.error("Παρακαλώ συμπληρώστε κατηγορία, υποκατηγορία και τύπο παραστατικού για την μισθοδοσία!");
        }

        if (!isEmpty(settings?.payrollConfiguration?.category) && !isEmpty(settings?.payrollConfiguration?.subCategory) && !isEmpty(settings?.payrollConfiguration?.documentType) && settings?.payrollConfiguration?.accounts?.length === 0) {
            return toast.error("Παρακαλώ συμπληρώστε λογιστικούς λογαριασμούς για την μισθοδοσία!");
        }

        if (settings?.payrollConfiguration?.accounts?.length > 0) {
            const accounts = settings?.payrollConfiguration?.accounts;
            if (accounts.length === 1) return toast.error("Παρακαλώ συμπληρώστε τουλάχιστον 2 λογαριασμούς για την μισθοδοσία");
            if (accounts.every((el) => el.type === "credit") || accounts.every((el) => el.type === "debit")) {
                return toast.error("Παρακαλώ συμπληρώστε λογαριασμούς πίστωσης και χρέωσης!");
            }
        }

        const cloneSetings = quickClone(settings);
        cloneSetings.installationActivities.forEach((inst) => {
            inst.activity = inst.activity.map((o) => o?.value || o);
        })
        // Post to API
        setLoadingSave(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/settings`, {
            ...cloneSetings,
            company: company.id,
            resetDefault,
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setAISettings(res.data.data));
                setSettings(res.data.data);
                if (resetDefault) setSettings({...defaultSettings, ...res.data.data});
                setShowResetAISettings(false);
                toast.success("Επιτυχής αποθήκευση.");
                if (resetDefault) dispatch(fetchCompanyDetails(company.id));
                dispatch(fetchBankingSettings(company.id));
            } else {
                toast.error(res.data.message);
            }
            setLoadingSave(false);
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            setLoadingSave(false);
        })
    }

    const handleOnChange = (e, type, name) => {
        const cloneIt = quickClone(settings);
        if (type === "cb") {
            cloneIt[name] = e.target.checked;
        } else if (type === "msdd") {
            cloneIt[name] = e.flatMap((o) => o.value);
        } else if (type === "slider") {
            cloneIt[name] = e;
        } else if (type === "dd") {
            cloneIt[name] = e.value;
            if (name === "batchSettlementsDefaultCP") cloneIt["batchSettlementsDefaultCPName"] = e.label;
            if (name === "batchSettlementsDefaultCPReturn") cloneIt["batchSettlementsDefaultCPReturnName"] = e.label;
            if (name === "prepaidStatementsDefaultSP") cloneIt["prepaidStatementsDefaultSPName"] = e.label;
            if (name === "prepaidStatementsDefaultSPReturn") cloneIt["prepaidStatementsDefaultSPReturnName"] = e.label;
        } else if (type === "input") {
            cloneIt[name] = e.target.value;
        }
        setSettings(cloneIt);
    }

    const handlePayrollOnChange = (e, type, name) => {
        const cloneIt = quickClone(settings);
        if (type === "cb") {
            cloneIt.payrollConfiguration[name] = e.target.checked;
        } else if (type === "dd") {
            if (name === "category") {
                cloneIt.payrollConfiguration["categoryName"] = e.label;
            } else if (name === "subCategory") {
                cloneIt.payrollConfiguration["subcategoryName"] = e.label;
            } else if (name === "documentType") {
                cloneIt.payrollConfiguration["documentTypeName"] = e.label;
            }
            cloneIt.payrollConfiguration[name] = e.value;
        } else if (type === "msdd") {
            cloneIt.payrollConfiguration[name] = e.flatMap((o) => o.value);
        } else if (type === "slider") {
            cloneIt.payrollConfiguration[name] = e;
        }
        setSettings(cloneIt);
    }

    const fetchPrimerCredentials = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/company/get-primer-mydata-credentials/`, {
                companyId: companyDetails?.primaryCompany || company.id
            });
            if (response.data && response.data.status === "200") {
                setPrimerCredentials(response.data.data);
            }
        } catch (error) {
            console.error("Σφάλμα κατά την αρχική ανάκτηση credentials:", error);
        }
    };

    const fetchPrimaryCompanyCounter = () => {
        if (!companyDetails?.primaryCompany) return;

        axios.get(`${process.env.REACT_APP_API_URL2}/ai/primary-company-counter`, {
            headers: { "Content-Type": "application/json" },
            params: { companyId: companyDetails.primaryCompany }
        }).then((res) => {
            if (res.data.status === "200") {
                setPrimaryCounter(res.data.counter);
            } else {
                console.log("Failed to fetch primary company counter:", res.data.message);
            }
        }).catch((err) => {
            console.error("Error fetching primary company counter:", err);
        });
    };

    const handleBuyCredits = () => {
        if (!primerCredentials) {
            return toast.error("Τα στοιχεία πρόσβασης MyData δεν έχουν φορτώσει ακόμα. Δοκιμάστε ξανά αργότερα.");
        }

        const packageIds = {
            500: "3576063",
            700: "3576062",
            1000: "3178521",
            2000: "3178523",
            5000: "3178522",
            10000: "3178524",
            20000: "4263107",
            30000: "4263108"
        };

        const productId = packageIds[selectedCreditAmount];
        const baseUrl = "https://primer.gr/checkout-2/";

        const params = new URLSearchParams({
            "add-to-cart": productId,
            "quantity": "1",
            "product_id": productId,
            "empty_cart": "true",
            "username": primerCredentials?.username || "",
            "password": primerCredentials?.password || ""
        });

        if (primaryCounter !== null && primaryCounter < 10) {
            params.append("apply_coupon", "QKX6U7S3");
        }

        params.append("vat_number_for_product", companyDetails?.vatNumber || "");

        const finalUrl = `${baseUrl}?${params.toString()}`;

        window.open(finalUrl, '_blank');
        setIsCheckingOut(true);
    };

    const handleBuyExtraCredits = () => {
        if (!primerCredentials) {
            return toast.error("Τα στοιχεία πρόσβασης MyData δεν έχουν φορτώσει ακόμα. Δοκιμάστε ξανά αργότερα.");
        }

        const productId = 2093824;
        const baseUrl = "https://primer.gr/checkout-2/";

        const params = new URLSearchParams({
            "add-to-cart": productId,
            "quantity": "1",
            "product_id": productId,
            "empty_cart": "true",
            "username": primerCredentials?.username || "",
            "password": primerCredentials?.password || ""
        });

        params.append("vat_number_for_product", companyDetails?.vatNumber || "");

        const finalUrl = `${baseUrl}?${params.toString()}`;

        window.open(finalUrl, '_blank');
        setIsCheckingOut(true);
    };

    const handleSyncOrderHistory = () => {
        if (!companyDetails?.vatNumber) {
            return toast.error("Δεν βρέθηκε το ΑΦΜ της εταιρείας για τον συγχρονισμό.");
        }

        setSyncOrderLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/order-history-credits`, {
            vatNumber: companyDetails.vatNumber
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data) {
                    setOrderData(res.data.data);
                    toast.success("Τα AI Credits ενημερώθηκαν επιτυχώς!");
                    setShowBuyCreditsModal(false);
                    setIsCheckingOut(false);
                } else {
                    toast.warning("Η διαδικασία ολοκληρώθηκε, αλλά δεν βρέθηκε νέα παραγγελία για αυτό το ΑΦΜ ακόμα. Δοκιμάστε ξανά αργότερα.");
                }
            } else {
                toast.error(res.data.message || "Σφάλμα κατά τον συγχρονισμό της παραγγελίας.");
            }
            setSyncOrderLoading(false);
        }).catch((err) => {
            console.error(err);
            toast.error("Σφάλμα επικοινωνίας με τον server.");
            setSyncOrderLoading(false);
        });
    };

    const handleRedirectToPrimerAccount = (targetPath = "view-subscription") => {
        if (!primerCredentials) {
            return toast.error("Τα στοιχεία πρόσβασης δεν είναι διαθέσιμα.");
        }

        const username = primerCredentials?.username || "";
        const password = primerCredentials?.password || "";

        if (targetPath === "renew") {
            const parentOrderId = orderData?.id || "";
            const productSku = orderData?.sku || "";
            const finalUrl = `https://primer.gr/?username=${username}&password=${password}&parent_order_id=${parentOrderId}&product_sku=${productSku}&renew=true`;

            window.open(finalUrl, '_blank');
        } else {
            if (!orderData?.id) {
                return toast.error("Δεν βρέθηκε αναγνωριστικό συνδρομής.");
            }

            const subscriptionId = orderData.subscription_id.toString() || "";
            const finalUrl = `https://primer.gr/my-account/${targetPath}/${subscriptionId}/?username=${username}%password=${password}`;

            window.open(finalUrl, '_blank');
        }
    };

    const documentTypeMappingColumns = [
        {
            name: "Τύπος Εγγραφής",
            field: "rowType",
            editable: true,
            required: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: getMyDataRowTypes(),
            }
        },
        {
            name: "Τύπος Εγγραφής",
            field: "myDataType",
            editable: true,
            required: true,
            width: "50%",
            inputType: {
                type: 'select',
                callbackOptions: (rowData) => {
                    if (rowData.rowType === "income") {
                        return [...salesInvoiceTypesData, {"id": "3.2", "myCodeData": "3.2", "name": "Τίτλος κτήσης (άρνηση χρέωσης από υπόχρεο Εκδότη)"}].map((o) => {
                            return {
                                value: o.myCodeData,
                                label: `${o.myCodeData} ${o.name}`,
                            }
                        });
                    } else if (rowData.rowType === "expense") {
                        return allInvoiceTypesData.map((o) => {
                            return {
                                value: o.myCodeData,
                                label: `${o.myCodeData} ${o.name}`,
                            }
                        });
                    }
                    return [];
                }
            }
        },
        {
            name: "Γενικό Παραστατικό",
            field: "documentType",
            editable: true,
            required: true,
            width: "35%",
            inputType: {
                type: 'select',
                callbackOptions: (rowData) => {
                    if (rowData.myDataType) {
                        if (rowData.rowType === "income") {
                            return SETTINGS.settings.advancedTypesSales?.filter((el) => el.myDataType === rowData.myDataType || rowData.myDataType === "3.2")?.map((o) => {
                                return {
                                    value: o._id,
                                    label: o.name,
                                }
                            });
                        } else if (rowData.rowType === "expense") {
                            return SETTINGS.settings.advancedTypesBuys?.filter((el) => el.myDataType === rowData.myDataType
                                || el?.classificationsArray?.includes(rowData.myDataType))?.map((o) => {
                                return {
                                    value: o._id,
                                    label: o.name,
                                }
                            });
                        }
                    }
                    return [];
                }
            }
        },
    ]

    const documentTypeMappingFunctions = {
        insert: (e, data) => {
            const initRow = {
                ...{...initDocumentTypeMapping},
                ...{
                    [data.field] : data.value,
                }
            }
            const cloneData = settings.documentTypeMapping.slice();
            cloneData.push(initRow);
            setSettings({...settings, documentTypeMapping: cloneData});
        },
        update: (data, id, rowIndex) => {
            const cloneData = structuredClone(settings.documentTypeMapping);
            if (data.rowType) {
                data.myDataType = "";
                data.documentType = "";
                data.documentTypeSection = "";
            } else if (data.myDataType) {
                data.documentType = "";
                data.documentTypeSection = "";
            } else if (data.documentType) {
                data.documentTypeSection = SETTINGS.settings.advancedTypesSales?.some((el) => el._id === data.documentType) ? "Sales" : "Buys";
            }
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            setSettings({...settings, documentTypeMapping: cloneData});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = structuredClone(settings.documentTypeMapping);
            cloneData.splice(rowIndex, 1);
            setSettings({...settings, documentTypeMapping: cloneData});
        },
    }

    const installationActivitiesColumns = [
        {
            name: "Εγκατάσταση",
            field: "installationMasterId",
            editable: true,
            required: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: installationOptions,
            }
        },
        {
            name: "Δραστηριότητα Εγκατάστασης",
            field: "activity",
            editable: true,
            required: true,
            width: "35%",
            inputType: {
                type: 'multiselectdropdown',
                options: activityOptions,
            }
        },
        {
            name: "Η εγκατάσταση έχει καθεστώς Φ.Π.Α. 0%",
            field: "vatRegime0",
            editable: true,
            width: "10%",
            inputType: {
                type: 'checkbox',
            }
        },
        {
            name: "Έλεγχος ύπαρξης παγίου ανά είδος",
            field: "assetIdentification",
            editable: true,
            width: "10%",
            inputType: {
                type: 'checkbox',
            }
        },
        {
            name: "Κατώτατη αξία για έλεγχο ύπαρξης παγίου",
            field: "assetLowerLimit",
            editable: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    type: "number",
                    suffix: "€",
                }
            }
        },
        {
            name: "Έλεγχος αναμόρφωσης ανά είδος",
            field: "anamorfosis",
            editable: true,
            width: "10%",
            inputType: {
                type: 'checkbox',
            }
        },
        {
            name: "Ποσοστό αναμόρφωσης σε παραστατικά ενοικίου",
            field: "anamorfosisPercentForRent",
            editable: true,
            width: "7%",
            inputType: {
                type: 'accounting',
                config: {
                    type: "number",
                    suffix: "%",
                }
            }
        },
        {
            name: "Ποσοστό αναμόρφωσης σε παραστατικά ΔΕΚΟ",
            field: "anamorfosisPercentForDEKO",
            editable: true,
            width: "7%",
            inputType: {
                type: 'accounting',
                config: {
                    type: "number",
                    suffix: "%",
                }
            }
        },
    ]

    const installationActivitiesFunctions = {
        insert: (e, data) => {
            const initRow = {
                ...{...initInstallationActivities},
                ...{
                    [data.field] : data.value,
                }
            }
            const cloneData = settings.installationActivities.slice();
            if (cloneData.some((el) => el.installationMasterId === initRow.installationMasterId)) {
                return toast.error("Έχεται ήδη επιλέξει αυτήν την εγκατάσταση.");
            }
            cloneData.push(initRow);
            setSettings({...settings, installationActivities: cloneData});
        },
        update: (data, id, rowIndex) => {
            const cloneData = structuredClone(settings.installationActivities);
            if (data.installationMasterId) {
                if (cloneData.some((el, idx) => el.installationMasterId === data.installationMasterId && rowIndex !== idx)) {
                    toast.error("Έχεται ήδη επιλέξει αυτήν την εγκατάσταση.");
                    setIncrKey2(incrKey2 + 1);
                    return;
                }
            }
            if (data?.anamorfosisPercentForRent && Number(data?.anamorfosisPercentForRent) > 100) {
                toast.error("Παρακαλώ εισάγετε σωστή τιμή ποσοστού!");
                setIncrKey2(incrKey2 + 1);
                return;
            }
            if (data?.anamorfosisPercentForDEKO && Number(data?.anamorfosisPercentForDEKO) > 100) {
                toast.error("Παρακαλώ εισάγετε σωστή τιμή ποσοστού!");
                setIncrKey2(incrKey2 + 1);
                return;
            }
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            setSettings({...settings, installationActivities: cloneData});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = structuredClone(settings.installationActivities);
            cloneData.splice(rowIndex, 1);
            setSettings({...settings, installationActivities: cloneData});
        },
    }

    const backwardTravelOptions = [
        {label: "1 μήνα πριν", value: "lastMonth"},
        {label: "2 μήνες πριν", value: "last2Months"},
        {label: "3 μήνες πριν", value: "last3Months"},
        {label: "6 μήνες πριν", value: "last6Months"},
        {label: "από την αρχή του έτους", value: "startOfTheYear"},
    ]

    const myDataReportClearanceDatesColumns = [
        {
            name: "Αριθμός ημέρας μηνός",
            field: "dayOfTheMonth",
            editable: true,
            inputType: {
                type: 'input',
                config: {
                    type: "number",
                }
            }
        },
        {
            name: "Χρονικό περιθώριο αναδρομικού ελέγχου",
            field: "backwardTravel",
            editable: true,
            required: true,
            inputType: {
                type: 'select',
                options: backwardTravelOptions,
            }
        },
    ]

    const backwardTravelTransactionsOptions = [
        {label: "Τρέχουσα ημερομηνία", value: "0"},
        {label: "1 μήνα πριν", value: "1"},
        {label: "2 μήνες πριν", value: "2"},
        {label: "3 μήνες πριν", value: "3"},
        {label: "4 μήνες πριν", value: "4"},
        {label: "5 μήνες πριν", value: "5"},
        {label: "6 μήνες πριν", value: "6"},
        {label: "7 μήνες πριν", value: "7"},
        {label: "8 μήνες πριν", value: "8"},
        {label: "9 μήνες πριν", value: "9"},
        {label: "10 μήνες πριν", value: "10"},
        {label: "11 μήνες πριν", value: "11"},
        {label: "12 μήνες πριν", value: "12"},
        {label: "από την αρχή του έτους", value: "100"},
    ]

    const transactionsClearanceDatesColumns = [
        {
            name: "Αριθμός ημέρας μηνός",
            field: "dayOfTheMonth",
            editable: true,
            inputType: {
                type: 'input',
                config: {
                    type: "number",
                }
            }
        },
        {
            name: "Τραπεζικοί Λογαριασμοί",
            field: "bankAccounts",
            editable: true,
            required: true,
            width: "35%",
            inputType: {
                type: 'multiselectdropdown',
                options: bankOptions,
            }
        },
        {
            name: "Χρονικό περιθώριο αναδρομικού ελέγχου Από:",
            field: "backwardTravelMonthFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'select',
                options: backwardTravelTransactionsOptions,
            }
        },
        {
            name: "Χρονικό περιθώριο αναδρομικού ελέγχου Μέχρι:",
            field: "backwardTravelMonthTo",
            editable: true,
            required: true,
            inputType: {
                type: 'select',
                options: backwardTravelTransactionsOptions,
            }
        },
    ]

    const myDataReportClearanceDatesFunctions = {
        insert: (e, data) => {
            if (data.value) {
                const initRow = {
                    ...{...initMyDataReportClearance},
                    ...{
                        [data.field] : data.value,
                    }
                }
                const cloneData = settings.myDataReportClearanceDates.slice();
                cloneData.push(initRow);
                setSettings({...settings, myDataReportClearanceDates: cloneData});
            }
        },
        update: (data, id, rowIndex) => {
            const cloneData = structuredClone(settings.myDataReportClearanceDates);
            if (data.dayOfTheMonth) {
                data.dayOfTheMonth = +data.dayOfTheMonth;
            }
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            setSettings({...settings, myDataReportClearanceDates: cloneData});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = structuredClone(settings.myDataReportClearanceDates);
            cloneData.splice(rowIndex, 1);
            setSettings({...settings, myDataReportClearanceDates: cloneData});
        },
    }

    const transactionsClearanceDatesFunctions = {
        insert: (e, data) => {
            if (data.value) {
                const initRow = {
                    ...{...initTransactionClearance},
                    ...{
                        [data.field] : data.value,
                    }
                }
                const cloneData = settings.aiTransactionsClearanceDates.slice();
                cloneData.push(initRow);
                setSettings({...settings, aiTransactionsClearanceDates: cloneData});
            }
        },
        update: (data, id, rowIndex) => {
            const cloneData = structuredClone(settings.aiTransactionsClearanceDates);
            if (data.dayOfTheMonth) {
                data.dayOfTheMonth = +data.dayOfTheMonth;
            }
            cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            setSettings({...settings, aiTransactionsClearanceDates: cloneData});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = structuredClone(settings.aiTransactionsClearanceDates);
            cloneData.splice(rowIndex, 1);
            setSettings({...settings, aiTransactionsClearanceDates: cloneData});
        },
    }

    const disabledStyle = {
        userSelect: "none",
        pointerEvents: "none",
        opacity: "0.65",
    }

    const loadAccounts = (keyword = null, setData) => {
        const reqData = {
            company: company.id,
        };
        if (keyword !== null) reqData.keyword = keyword;

        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/account-list-by-advanced-type-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                code: keyword !== null ? keyword : undefined,
            }
        }).then((res) => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) setData(res.data.data);
                else setData([]);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const subCategoryAccountTableColumns = [
        {
            name: "Κωδικός Λογαριασμού",
            field: "code",
            width: "15%",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadAccounts(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Κωδικός Λογαριασμού", name: "code"},
                        {label: "Όνομα Λογαριασμού", name: "name"},
                    ],
                    data: accounts,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε λογιστικό λογαριασμό",
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Όνομα Λογαριασμού",
            field: "name",
            width: "25%",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadAccounts(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Κωδικός Λογαριασμού", name: "code"},
                        {label: "Όνομα Λογαριασμού", name: "name"},
                    ],
                    data: accounts,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε λογιστικό λογαριασμό",
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Υποκατηγορία Λογαριασμού",
            field: "subAccountType",
            width: "15%",
            editable: true,
            disabled: true,
            placeholder: "Δεν υποστηρίζει",
            inputType: {
                options: getSubaccountOptions(),
                type: "select",
            }
        },
        {
            name: "Τύπος Γραμμής",
            field: "type",
            width: "10%",
            editable: true,
            inputType: {
                type: "select",
                options: [
                    {label: "Χρέωση", value: "debit"},
                    {label: "Πίστωση", value: "credit"},
                ],
            }
        },
        {
            name: "Περιγραφή Λογιστικού Λογαριασμού",
            field: "accountDescription",
            width: "50%",
            editable: true,
            disabled: user?.userType !== "Admin",
            inputType: {
                type: "textarea"
            }
        },
    ]

    const onTableAccountsChange = {
        insert: (e, data) => {
            if (data.field === "name" || data.field === "code") {
                const initRow = {
                    code: e.row.code,
                    name: e.row.name,
                    type: "credit",
                    subAccountType: e.row?.subAccount ? e.row.subAccount : "",
                }
                const cloneData = settings?.payrollConfiguration?.accounts.slice();
                cloneData.push(initRow);
                setSettings({...settings, payrollConfiguration: {...settings.payrollConfiguration, accounts: cloneData}});
            }
        },
        update: (data, id, rowIndex, e) => {
            const cloneData = quickClone(settings?.payrollConfiguration?.accounts);
            if (data.name || data.code) {
                const matchingAcc = e.row;
                if (matchingAcc) {
                    cloneData[rowIndex] = {
                        ...cloneData[rowIndex],
                        code: matchingAcc.code,
                        name: matchingAcc.name,
                        subAccountType: e.row.subAccount,
                    }
                }
            } else {
                cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            }
            setSettings({...settings, payrollConfiguration: {...settings.payrollConfiguration, accounts: cloneData}});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = quickClone(settings?.payrollConfiguration?.accounts);
            cloneData.splice(rowIndex, 1);
            setSettings({...settings, payrollConfiguration: {...settings.payrollConfiguration, accounts: cloneData}});
        },
    }

    const showBuyButton = !isEmpty(companyDetails?.primaryCompany) && isEmpty(orderData);

    return (
        <React.Fragment>
            {orderData && (
                <Row>
                    <Col md={6} sm={12}>
                        <Card className="shadow-md">
                            <Card.Body className="p-3">
                                <Card.Title className="font-weight-bold mb-3 border-bottom pb-2">
                                    <i className="fas fa-box-open mr-2 text-primary"></i>
                                    {orderData.productName}
                                </Card.Title>
                                <Row>
                                    <Col md={4}>
                                        <span className="text-muted d-block" style={{ fontSize: "0.85rem" }}>Πακέτο AI Credits</span>
                                        <strong style={{ fontSize: "1.1rem" }}>{orderData.aiCredits}</strong>
                                    </Col>
                                    <Col md={4}>
                                        <span className="text-muted d-block" style={{ fontSize: "0.85rem" }}>Τιμή</span>
                                        <strong style={{ fontSize: "1.1rem" }}>{getGreekCurrencyFormat(+orderData.subscription_price / 14.88, 2)}</strong>
                                    </Col>
                                    <Col md={4}>
                                        <span className="text-muted d-block" style={{ fontSize: "0.85rem" }}>Κατάσταση</span>
                                        <div>
                                            <Badge
                                                bg={
                                                    orderData.next_payment_date && moment(orderData.next_payment_date).isBefore(moment())
                                                        ? 'danger'
                                                        : orderData.status === 'completed' ? 'primary' : 'primary'
                                                }
                                            >
                                                {orderData.next_payment_date && moment(orderData.next_payment_date).isBefore(moment())
                                                    ? 'Έχει Λήξει'
                                                    : orderData.status === 'completed' ? 'Ενεργή' : orderData.status
                                                }
                                            </Badge>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer className="bg-white d-flex border-top justify-content-start p-3">
                                <Button variant="primary" className="mr-2" size="sm" onClick={() => handleRedirectToPrimerAccount("view-subscription")}>
                                    Εμφάνιση συνδρομής στην ιστοσελίδα
                                </Button>
                                <Button variant="primary" className="mr-2" size="sm" onClick={() => handleRedirectToPrimerAccount("view-subscription")}>
                                    Αναβάθμιση συνδρομής
                                </Button>
                                {orderData.next_payment_date && moment(orderData.next_payment_date).isBefore(moment()) && (
                                    <Button variant="primary" size="sm" onClick={() => handleRedirectToPrimerAccount("renew")}>
                                        Ανανέωση συνδρομής
                                    </Button>
                                )}
                                <Button variant="primary" className="mr-2" size="sm" onClick={() => handleBuyExtraCredits()}>
                                    Αγορά Extra Credits
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            )}
            <Row>
                <div className={"text-muted mb-2"}><i>Ρυθμίσεις Cloud AI</i></div>
                <Row className="mb-2 align-items-center">
                    <Col md={3}>
                        <BetterCheckBox
                            name="enableCloudAI"
                            className={"mt-2"}
                            text="Ενεργοποίηση Cloud AI"
                            checked={settings.enableCloudAI}
                            onChange={(e) => handleOnChange(e, "cb", "enableCloudAI")}
                        />
                    </Col>
                    <Col md={5}>
                        <AICreditsUsage onUsageFetch={(data) => setCreditsUsageData(data)}/>
                        {showBuyButton && (
                            <Button
                                className={creditsUsageData?.maximum > 0 ? "mt-2" : ""}
                                onClick={() => setShowBuyCreditsModal(true)}
                            >
                                {primaryCounter !== null && primaryCounter < 10
                                    ? "Αγορά AI Credits με 3 μήνες δωρεάν χρήση"
                                    : "Αγορά AI Credits"
                                }
                            </Button>
                        )}
                    </Col>
                    <Col md={4} className="d-flex justify-content-end">
                        <Button disabled={!settings.enableCloudAI} onClick={() => setShowSyncProductsModal(true)}>
                            Κατάσταση Συγχρονισμού Δεδομένων
                        </Button>
                    </Col>
                </Row>
                <div style={!settings.enableCloudAI ? disabledStyle : {}}>
                    <Row className={"mb-2"}>
                        <Col md={8}>
                            <Dropdown
                                name={"unshortedFolders"}
                                label={"Φάκελοι όπου το περιεχόμενο τους θα αποστέλλεται στο Primer AI"}
                                multiSelect={true}
                                key={Math.random()}
                                options={registerOrSortToOptionsDD}
                                defaultValue={registerOrSortToOptionsDD.filter((el) => settings.unshortedFolders.includes(el.value))}
                                onChange={(e) => handleOnChange(e, "msdd", "unshortedFolders")}
                            />
                        </Col>
                        <Col md={4}>
                            <BetterCheckBox
                                name={"batchAI"}
                                text={"Ενεργοποίηση μαζικής και ασύγχρονης αποστολής δεδομένων στο Primer AI (Batching)"}
                                checked={settings.batchAI}
                                className={"mt-3"}
                                onChange={(e) => handleOnChange(e, "cb", "batchAI")}
                            />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <div className={"text-muted mb-2"}><i>Αντιστοιχία Εγκαταστάσεων και Δραστηριοτήτων</i></div>
                            <EditableTable
                                tableName="AI Settings Installation Activities"
                                key={"AISIA" + incrKey2}
                                allowActions={true}
                                onUpdate={installationActivitiesFunctions}
                                allowInsertRow="true"
                                columns={installationActivitiesColumns}
                                enableNewRowCheckbox={false}
                                data={settings.installationActivities}
                            />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Αντιστοιχία τύπων MyData και Γενικών
                                        Παραστατικών</Accordion.Header>
                                    <Accordion.Body>
                                        <EditableTable
                                            tableName="AI Settings Document Mapping"
                                            key={"AISDM" + incrKey1}
                                            allowActions={true}
                                            onUpdate={documentTypeMappingFunctions}
                                            allowInsertRow="true"
                                            columns={documentTypeMappingColumns}
                                            enableNewRowCheckbox={false}
                                            data={settings.documentTypeMapping}
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Ρυθμίσεις Λογιστικού Εγγράφου Μισθοδοσίας</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className={"mb-2"}>
                                            <Col md={12}>
                                                <BetterCheckBox
                                                    name={"enablePayroll"}
                                                    text={"Ενεργοποίηση εντοπισμού μισθοδοσιών"}
                                                    className={"m-0"}
                                                    checked={settings?.enablePayroll}
                                                    onChange={(e) => handleOnChange(e, "cb", "enablePayroll")}
                                                />
                                            </Col>
                                        </Row>
                                        <div style={!settings?.enablePayroll ? disabledStyle : {}}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className={"text-muted mb-2"}><i>Ρυθμίσεις Παραστατικού</i></div>
                                                </Col>
                                            </Row>
                                            <Row className="border-bottom mb-3">
                                                <Col sm={12} md={3} className={"mb-3"}>
                                                    <Dropdown
                                                        className={"showWithOverlay mb-0"}
                                                        label={t("General.category")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(categories, settings?.payrollConfiguration?.category, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name="category"
                                                        options={categories}
                                                        onChange={(e) => handlePayrollOnChange(e, 'dd', 'category')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        className={"showWithOverlay"}
                                                        label={t("General.subCategory")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(subCategories, settings?.payrollConfiguration?.subCategory, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name="subCategory"
                                                        options={subCategories}
                                                        onChange={(e) => handlePayrollOnChange(e, 'dd', 'subCategory')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        className={"showWithOverlay"}
                                                        label={t("General.logTypes")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(getRecordTypeOptions(), settings?.payrollConfiguration?.recordType, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name="recordType"
                                                        options={getRecordTypeOptions()}
                                                        onChange={(e) => handlePayrollOnChange(e, 'dd', 'recordType')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        label={t('SalesNew.DocumentType')}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(documentTypesOptions, settings?.payrollConfiguration?.documentType, 'value', 'label', 'value')}
                                                        required={true}
                                                        searchEnable={true}
                                                        name="documentType"
                                                        options={documentTypesOptions}
                                                        onChange={(e) => handlePayrollOnChange(e, 'dd', 'documentType')}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <div className={"text-muted mb-2"}><i>Λογαριασμοί Παραστατικού</i></div>
                                                </Col>
                                                <Col md={12} className={"mt-3"}>
                                                    <EditableTable
                                                        tableName={"SubCategory Account Table"}
                                                        key={"AISAT" + incrKey5}
                                                        allowActions={true}
                                                        onUpdate={onTableAccountsChange}
                                                        allowInsertRow="true"
                                                        columns={subCategoryAccountTableColumns}
                                                        enableNewRowCheckbox={true}
                                                        data={settings?.payrollConfiguration?.accounts}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Ρυθμίσεις Πακέτων Καρτών</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className={"mb-2 mt-1"}>
                                            <Col md={12}>
                                                <BetterCheckBox
                                                    name={"enableBatchSettlements"}
                                                    text={"Ενεργοποίηση εντοπισμού πακέτων καρτών από POS"}
                                                    className={"m-0"}
                                                    checked={settings?.enableBatchSettlements}
                                                    onChange={(e) => handleOnChange(e, "cb", "enableBatchSettlements")}
                                                />
                                            </Col>
                                        </Row>
                                        <div style={!settings.enableBatchSettlements ? disabledStyle : {}}>
                                            <Row>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Γενικό Παραστατικό Είσπραξης"}
                                                        key={Math.random()}
                                                        defaultValue={clientPaymentOptions.find((el) => el.value === settings.batchSettlementsDefaultCP)}
                                                        required={false}
                                                        name={"batchSettlementsDefaultCP"}
                                                        options={clientPaymentOptions}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'batchSettlementsDefaultCP')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Σειρά Είσπραξης"}
                                                        key={Math.random()}
                                                        defaultValue={preNumberGreek.find((el) => el.value === settings.batchSettlementsDefaultCPPreNumber)}
                                                        required={false}
                                                        name={"batchSettlementsDefaultCPPreNumber"}
                                                        options={preNumberGreek}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'batchSettlementsDefaultCPPreNumber')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Γενικό Παραστατικό Επιστροφής Είσπραξης"}
                                                        key={Math.random()}
                                                        defaultValue={clientPaymentOptions.find((el) => el.value === settings.batchSettlementsDefaultCPReturn)}
                                                        required={false}
                                                        name={"batchSettlementsDefaultCPReturn"}
                                                        options={clientPaymentOptions}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'batchSettlementsDefaultCPReturn')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Σειρά Επιστροφής Είσπραξης"}
                                                        key={Math.random()}
                                                        defaultValue={preNumberGreek.find((el) => el.value === settings.batchSettlementsDefaultCPReturnPreNumber)}
                                                        required={false}
                                                        name={"batchSettlementsDefaultCPReturnPreNumber"}
                                                        options={preNumberGreek}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'batchSettlementsDefaultCPReturnPreNumber')}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Ρυθμίσεις πληρωμών μέσω Prepaid / Πιστωτικών</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className={"mb-2 mt-1"}>
                                            <Col md={12}>
                                                <BetterCheckBox
                                                    name={"enablePrepaidStatements"}
                                                    text={"Ενεργοποίηση εντοπισμού συναλλαγών prepaid εταιρικών καρτών"}
                                                    className={"m-0"}
                                                    checked={settings?.enablePrepaidStatements}
                                                    onChange={(e) => handleOnChange(e, "cb", "enablePrepaidStatements")}
                                                />
                                            </Col>
                                        </Row>
                                        <div style={!settings.enablePrepaidStatements ? disabledStyle : {}}>
                                            <Row>
                                                {/*
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Τρόπος Πληρωμής Πληρωμών"}
                                                        key={Math.random()}
                                                        defaultValue={buysPaymentTypes.find((el) => el.value === settings.prepaidStatementsDefaultPaymentType)}
                                                        required={false}
                                                        name={"prepaidStatementsDefaultPaymentType"}
                                                        options={buysPaymentTypes}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'prepaidStatementsDefaultPaymentType')}
                                                    />
                                                </Col>
                                                */}
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Γενικό Παραστατικό Πληρωμών"}
                                                        key={Math.random()}
                                                        defaultValue={supplierPaymentsOptions.find((el) => el.value === settings.prepaidStatementsDefaultSP)}
                                                        required={false}
                                                        name={"prepaidStatementsDefaultSP"}
                                                        options={supplierPaymentsOptions}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'prepaidStatementsDefaultSP')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Σειρά Πληρωμών"}
                                                        key={Math.random()}
                                                        defaultValue={preNumberGreek.find((el) => el.value === settings.prepaidStatementsDefaultSPPreNumber)}
                                                        required={false}
                                                        name={"prepaidStatementsDefaultSPPreNumber"}
                                                        options={preNumberGreek}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'prepaidStatementsDefaultSPPreNumber')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Γενικό Παραστατικό Επιστροφής Πληρωμών"}
                                                        key={Math.random()}
                                                        defaultValue={supplierPaymentsOptions.find((el) => el.value === settings.prepaidStatementsDefaultSPReturn)}
                                                        required={false}
                                                        name={"prepaidStatementsDefaultSPReturn"}
                                                        options={supplierPaymentsOptions}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'prepaidStatementsDefaultSPReturn')}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Dropdown
                                                        label={"Σειρά Επιστροφής Πληρωμών"}
                                                        key={Math.random()}
                                                        defaultValue={preNumberGreek.find((el) => el.value === settings.prepaidStatementsDefaultSPReturnPreNumber)}
                                                        required={false}
                                                        name={"prepaidStatementsDefaultSPReturnPreNumber"}
                                                        options={preNumberGreek}
                                                        onChange={(e) => handleOnChange(e, 'dd', 'prepaidStatementsDefaultSPReturnPreNumber')}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        label={t("General.category")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(categories, settings.prepaidStatementsAccountingCategory, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name={"category"}
                                                        options={categories}
                                                        onChange={(e) => handleOnChange(e, "dd", 'prepaidStatementsAccountingCategory')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        label={t("General.subCategory")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(subCategories, settings.prepaidStatementsAccountingSubCategory, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name={"subCategory"}
                                                        options={subCategories}
                                                        onChange={(e) => handleOnChange(e, "dd", 'prepaidStatementsAccountingSubCategory')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        label={t("General.logTypes")}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(getRecordTypeOptions(), settings.prepaidStatementsAccountingRecordType, 'value', 'label', 'value')}
                                                        searchEnable={true}
                                                        required={true}
                                                        name={"recordType"}
                                                        options={getRecordTypeOptions()}
                                                        onChange={(e) => handleOnChange(e, "dd", 'prepaidStatementsAccountingRecordType')}
                                                    />
                                                </Col>
                                                <Col sm={12} md={3}>
                                                    <Dropdown
                                                        label={t('SalesNew.DocumentType')}
                                                        key={Math.random()}
                                                        defaultValue={getDefaultOptionByValue(documentTypesOptions, settings.prepaidStatementsAccountingDocumentType, 'value', 'label', 'value')}
                                                        required={true}
                                                        searchEnable={true}
                                                        name={"documentType"}
                                                        options={documentTypesOptions}
                                                        onChange={(e) => handleOnChange(e, "dd", 'prepaidStatementsAccountingDocumentType')}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}>
                                                    <Input
                                                        name={"prepaidStatementsPrepaidBucketAccount"}
                                                        label={"Συγκεντρωτικός Λογ. Λογαριασμός Prepaid"}
                                                        value={settings.prepaidStatementsPrepaidBucketAccount}
                                                        onChange={(e) => handleOnChange(e, "input", "prepaidStatementsPrepaidBucketAccount")}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Input
                                                        name={"prepaidStatementsPrepaidCardAccount"}
                                                        label={"Λογ. Λογαριασμός Prepaid"}
                                                        value={settings.prepaidStatementsPrepaidCardAccount}
                                                        onChange={(e) => handleOnChange(e, "input", "prepaidStatementsPrepaidCardAccount")}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Input
                                                        name={"prepaidStatementsCreditBucketAccount"}
                                                        label={"Συγκεντρωτικός Λογ. Λογαριασμός Πιστωτικών"}
                                                        value={settings.prepaidStatementsCreditBucketAccount}
                                                        onChange={(e) => handleOnChange(e, "input", "prepaidStatementsCreditBucketAccount")}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Input
                                                        name={"prepaidStatementsCreditCardAccount"}
                                                        label={"Λογ. Λογαριασμός Πιστωτικών"}
                                                        value={settings.prepaidStatementsCreditCardAccount}
                                                        onChange={(e) => handleOnChange(e, "input", "prepaidStatementsCreditCardAccount")}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <div className={"text-muted mb-2"}><i>Λοιπές ρυθμίσεις</i></div>
                        </Col>
                        <Col md={3}>
                            <Popover placement={"top"} content={
                                <div style={{maxWidth: "300px"}}>
                                    Θα γίνεται διασταύρωση των αρ. πινακίδων των οχημάτων αναλόγως την κατηγορία τους
                                    έτσι ώστε να γίνεται
                                    σωστά ο χαρακτηρισμός εξόδων καυσίμων/leasing/επισκευών και λοιπά, από το Primer AI.
                                </div>
                            } title={""}>
                                <div style={{width: "100%", height: "100%"}}>
                                    <BetterCheckBox
                                        name={"companyVehiclesCheck"}
                                        text={"Ενεργοποίηση ελέγχου οχημάτων σε παραστατικά"}
                                        checked={settings.companyVehiclesCheck}
                                        onChange={(e) => handleOnChange(e, "cb", "companyVehiclesCheck")}
                                    />
                                </div>
                            </Popover>
                        </Col>
                        <Col md={3}>
                            <Popover placement={"top"} content={
                                <div style={{maxWidth: "300px"}}>
                                    Σε περίπτωση ενεργοποίησης της ρύθμισης αυτής, θα γίνεται αναλυτική αποθήκευση κάθε
                                    είδους στην αποθήκη.
                                    Σε αντίθετη περίπτωση θα δημιουργείται ένα γενικότερο είδος με βάση την γενική
                                    υποκατηγορία του.
                                </div>
                            } title={""}>
                                <div style={{width: "100%", height: "100%"}}>
                                    <BetterCheckBox
                                        name={"analyticProductsInBuys"}
                                        text={"Αναλυτική αποθήκευση ειδών από τις αγορές"}
                                        checked={settings.analyticProductsInBuys}
                                        onChange={(e) => handleOnChange(e, "cb", "analyticProductsInBuys")}
                                    />
                                </div>
                            </Popover>
                        </Col>
                        <Col md={6}>
                            <div style={{textAlign: "center"}}>
                                <h6>Επίπεδο αυστηρότητας εκπιπτόμενου Φ.Π.Α. στις Αγορές</h6>
                            </div>
                            <StatusSlider
                                min={1}
                                max={5}
                                labels={vatDeductibleToleranceLabels}
                                value={settings.vatDeductibleTolerance}
                                onChange={(e) => handleOnChange(e, "slider", "vatDeductibleTolerance")}
                            />
                        </Col>
                    </Row>
                    <hr/>
                    <Row className={"mb-2"}>
                        <div className={"text-muted mb-2"}><i>Ρυθμίσεις διασταύρωσης με MyData Vision</i></div>
                        <Col md={3}>
                            <BetterCheckBox
                                name={"myDataReportClearance"}
                                text={"Ενεργοποίηση διασταύρωσης με MyData Vision"}
                                checked={settings.myDataReportClearance}
                                onChange={(e) => handleOnChange(e, "cb", "myDataReportClearance")}
                            />
                        </Col>
                        <Col md={3} style={!settings.myDataReportClearance ? disabledStyle : {}}>
                            <BetterCheckBox
                                name={"myDataReportSalesClearance"}
                                text={"Διασταύρωση Πωλήσεων"}
                                checked={settings.myDataReportSalesClearance}
                                onChange={(e) => handleOnChange(e, "cb", "myDataReportSalesClearance")}
                            />
                        </Col>
                        <Col md={3} style={!settings.myDataReportClearance ? disabledStyle : {}}>
                            <BetterCheckBox
                                name={"myDataReportBuysClearance"}
                                text={"Διασταύρωση Αγορών & Δαπανών"}
                                checked={settings.myDataReportBuysClearance}
                                onChange={(e) => handleOnChange(e, "cb", "myDataReportBuysClearance")}
                            />
                        </Col>
                        {user?.userType === "Admin" && (
                            <Col md={3}>
                                <BetterCheckBox
                                    name={"disableAiCreditsOnSales"}
                                    text={"Απενεργοποίηση Χρέωσης AI Credits στις Πωλήσεις"}
                                    checked={settings?.disableAiCreditsOnSales}
                                    className={"m-0"}
                                    onChange={(e) => handleOnChange(e, "cb", "disableAiCreditsOnSales")}
                                />
                            </Col>
                        )}
                    </Row>
                    <div style={!settings.myDataReportClearance ? disabledStyle : {}}>
                        <Row className={"mb-2"}>
                            <Col md={12}>
                                <div className={"text-muted mb-2"}><i>Ρυθμίσεις ημερών διασταύρωσης με MyData Vision</i>
                                </div>
                                <EditableTable
                                    tableName="AI Settings MyData Report Clearance"
                                    key={"AISMRC" + incrKey3}
                                    allowActions={true}
                                    onUpdate={myDataReportClearanceDatesFunctions}
                                    allowInsertRow="true"
                                    columns={myDataReportClearanceDatesColumns}
                                    enableNewRowCheckbox={false}
                                    data={settings.myDataReportClearanceDates}
                                />
                            </Col>
                        </Row>
                        <Row className={"d-flex justify-content-start align-items-center"}>
                            {!isEmpty(settings?.nextCronJobRun) && (
                                <Col md={3}><span style={{fontStyle: "italic"}}><i>Ημερομηνία Επόμενης Εκτέλεσης Ελέγχου: {moment(settings.nextCronJobRun).format("DD/MM/YYYY HH:mm:ss")}</i></span></Col>
                            )}
                            {!isEmpty(settings?.lastCronJobRun) && (
                                <Col md={4}><span style={{fontStyle: "italic"}}><i>Ημερομηνία Τελευταίας Εκτέλεσης Ελέγχου: {moment(settings.lastCronJobRun).format("DD/MM/YYYY HH:mm:ss")}</i></span></Col>
                            )}
                            <Col md={4}>
                                <Button disabled={!settings.myDataReportClearance || runCronJobLoader}
                                        onClick={() => runMrCronJob()}>
                                    Εκτέλεση Διασταύρωσης Τώρα {runCronJobLoader &&
                                    <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Row>
            <hr/>
            <Row>
                <div className={"text-muted"}><i>Ρυθμίσεις AI Όψεως</i></div>
                <Row className={"align-items-center"}>
                    <Col md={3}>
                        <BetterCheckBox
                            name={"enableBankingAI"}
                            text={"Ενεργοποίηση AI Όψεως"}
                            className={"mt-2"}
                            checked={settings.enableBankingAI}
                            onChange={(e) => handleOnChange(e, "cb", "enableBankingAI")}
                        />
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <Button disabled={!settings.enableBankingAI} onClick={() => setShowSyncBankModal(true)}>
                            Κατάσταση Συγχρονισμού Δεδομένων
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={5}>
                        <BetterCheckBox
                            name={"enableBankingBatchAI"}
                            text={"Ενεργοποίηση μαζικής και ασύγχρονης αποστολής δεδομένων στο Primer AI (Batching)"}
                            checked={settings.enableBankingBatchAI}
                            className={"mt-3"}
                            onChange={(e) => handleOnChange(e, "cb", "enableBankingBatchAI")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <BetterCheckBox
                            name={"aiTransactionsClearance"}
                            text={"Ενεργοποίηση αυτόματης επεξεργασίας συναλλαγών από το Primer AI"}
                            checked={settings.aiTransactionsClearance}
                            className={"mt-3"}
                            onChange={(e) => handleOnChange(e, "cb", "aiTransactionsClearance")}
                        />
                    </Col>
                </Row>
                <div style={!settings.aiTransactionsClearance ? disabledStyle : {}}>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <div className={"text-muted mb-2"}><i>Ρυθμίσεις αυτόματης εκτέλεσης συναλλαγών</i></div>
                            <EditableTable
                                tableName="AI Settings Transactions Clearance"
                                key={"AISTRC" + incrKey4}
                                allowActions={true}
                                onUpdate={transactionsClearanceDatesFunctions}
                                allowInsertRow="true"
                                columns={transactionsClearanceDatesColumns}
                                enableNewRowCheckbox={false}
                                data={settings.aiTransactionsClearanceDates}
                            />
                        </Col>
                    </Row>
                    <Row className={"d-flex justify-content-start align-items-center"}>
                        {!isEmpty(settings?.nextTransactionsCronJobRun) && (
                            <Col md={3}><span
                                style={{fontStyle: "italic"}}><i>Ημερομηνία Επόμενης Εκτέλεσης Ελέγχου: {moment(settings.nextTransactionsCronJobRun).format("DD/MM/YYYY HH:mm:ss")}</i></span></Col>
                        )}
                        {!isEmpty(settings?.lastTransactionsCronJobRun) && (
                            <Col md={4}><span
                                style={{fontStyle: "italic"}}><i>Ημερομηνία Τελευταίας Εκτέλεσης Ελέγχου: {moment(settings.lastTransactionsCronJobRun).format("DD/MM/YYYY HH:mm:ss")}</i></span></Col>
                        )}
                        <Col md={4}>
                            <Button disabled={!settings.aiTransactionsClearanceDates || runTransactionsCronJobLoader}
                                    onClick={() => runTransactionsCronJob()}>
                                Εκτέλεση Επεξεργασίας Τώρα {runTransactionsCronJobLoader &&
                                <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Row>
            {user?.userType === "Admin" && (
                <Row className={"mt-4"}>
                    <Col md={4}>
                        <BetterCheckBox
                            name={"disableWebSearchOnIncomes"}
                            text={"Απενεργοποίηση Web Searching στα εισερχόμενα εμβάσματα"}
                            checked={settings?.disableWebSearchOnIncomes}
                            className={"m-0"}
                            onChange={(e) => handleOnChange(e, "cb", "disableWebSearchOnIncomes")}
                        />
                    </Col>
                    <Col md={4}>
                        <BetterCheckBox
                            name={"disableWebSearchOnExpenses"}
                            text={"Απενεργοποίηση Web Searching στα εξερχόμενα εμβάσματα"}
                            checked={settings?.disableWebSearchOnExpenses}
                            className={"m-0"}
                            onChange={(e) => handleOnChange(e, "cb", "disableWebSearchOnExpenses")}
                        />
                    </Col>
                </Row>
            )}
            <Row className={"d-flex justify-content-end mt-3"}>
                <Col md={3} className={"d-flex justify-content-end"}>
                    <Button className={"mr-2"} onClick={() => setShowResetAISettings(true)} disabled={loadingSave}>
                        Αρχικοποίηση ρυθμίσεων AI
                    </Button>
                    {user?.userType === "Admin" && (
                        <Button className={"mr-2"} onClick={() => setShowDemoVectorModal(true)} disabled={loadingSave}>
                            Demo Vector
                        </Button>
                    )}
                    <Button onClick={() => saveSettings()} disabled={loadingSave}>
                        Αποθήκευση {loadingSave && <Spinner className={"ml-2"} animation="border" variant="dark" />}
                    </Button>
                </Col>
            </Row>
            <Modal backdrop={"static"} className="themeModal" show={showSyncProductsModal} onHide={() => setShowSyncProductsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Συγχρονισμός Δεδομένων στο Primer AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {syncDataLoader ? (<span className="spinner-border spinner-border-sm ml-1 align-items-center" role="status" aria-hidden="true"></span>) : (
                        <React.Fragment>
                            <Row>
                                <Col md={12} className="d-flex align-items-center justify-content-center">
                                    <span style={{fontStyle: "italic"}}><i>Ημερομηνία Τελευταίου Συγχρονισμού: {syncData?.productsVectorLastSyncDate ? moment(syncData?.productsVectorLastSyncDate).format("DD/MM/YYYY HH:mm:ss"): ""}</i></span>
                                    <Button
                                        disabled={syncDataLoader}
                                        className="ml-5 mr-2"
                                        size="sm"
                                        onClick={() => fetchSyncData()}>
                                        {!syncDataLoader && (<i className="fa-solid fa-rotate" style={{fontSize: "12px"}}></i>)}
                                        {syncDataLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>
                            <hr style={{marginTop: "0.3rem", marginBottom: "0.3rem"}} />
                            {syncData?.unsyncedProducts > 0 ? (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <MdOutlineSyncProblem size={40} color="red" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>{syncData?.unsyncedProducts}{" "}{syncData?.unsyncedProducts === 1 ? "Προϊόν δεν είναι συγχρονισμένο" : "Προϊόντα δεν είναι συγχρονισμένα"}{" "}με το Primer AI</span>
                                </div>
                            ) : (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <IoCheckmarkDoneCircleSharp size={40} color="green" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>
                                        Όλα τα Προϊόντα είναι συγχρονισμένα με το Primer AI
                                    </span>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
                {!syncDataLoader && (
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            disabled={syncLoader}
                            onClick={() => syncProductDataNow()}>
                            {"Συγχρονισμός Τώρα "}
                            {syncLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>

            <Modal backdrop={"static"} className="themeModal" show={showSyncBankModal} onHide={() => setShowSyncBankModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Συγχρονισμός Δεδομένων στο Primer AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {syncDataLoader ? (<span className="spinner-border spinner-border-sm ml-1 align-items-center" role="status" aria-hidden="true"></span>) : (
                        <React.Fragment>
                            <Row>
                                <Col md={12} className="d-flex align-items-center justify-content-center">
                                    <span style={{fontStyle: "italic"}}><i>Ημερομηνία Τελευταίου Συγχρονισμού: {syncData?.bankVectorLastSyncDate ? moment(syncData?.bankVectorLastSyncDate).format("DD/MM/YYYY HH:mm:ss"): ""}</i></span>
                                    <Button
                                        disabled={syncDataLoader}
                                        className="ml-5 mr-2"
                                        size="sm"
                                        onClick={() => fetchSyncData()}>
                                        {!syncDataLoader && (<i className="fa-solid fa-rotate" style={{fontSize: "12px"}}></i>)}
                                        {syncDataLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>
                            <hr style={{marginTop: "0.3rem", marginBottom: "0.3rem"}} />
                            {syncData?.unsyncedClients > 0 ? (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <MdOutlineSyncProblem size={40} color="red" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>{syncData?.unsyncedClients}{" "}{syncData?.unsyncedClients === 1 ? "Πελάτης δεν είναι συγχρονισμένος" : "Πελάτες δεν είναι συγχρονισμένοι"}{" "}με το Primer AI</span>
                                </div>
                            ) : (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <IoCheckmarkDoneCircleSharp size={40} color="green" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>
                                        Όλοι οι πελάτες είναι συγχρονισμένοι με το Primer AI
                                    </span>
                                </div>
                            )}
                            <hr style={{marginTop: "0.3rem", marginBottom: "0.3rem"}} />
                            {syncData?.unsyncedSuppliers > 0 ? (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <MdOutlineSyncProblem size={40} color="red" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>{syncData?.unsyncedSuppliers}{" "}{syncData?.unsyncedSuppliers === 1 ? "Προμηθευτής δεν είναι συγχρονισμένος" : "Προμηθευτές δεν είναι συγχρονισμένοι"}{" "}με το Primer AI</span>
                                </div>
                            ) : (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <IoCheckmarkDoneCircleSharp size={40} color="green" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>
                                        Όλοι οι προμηθευτές είναι συγχρονισμένοι με το Primer AI
                                    </span>
                                </div>
                            )}
                            <hr style={{marginTop: "0.3rem", marginBottom: "0.3rem"}} />
                            {syncData?.unsyncedTransactions > 0 ? (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <MdOutlineSyncProblem size={40} color="red" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>{syncData?.unsyncedTransactions}{" "}{syncData?.unsyncedTransactions === 1 ? "Συναλλαγή δεν είναι συγχρονισμένη" : "Συναλλαγές δεν είναι συγχρονισμένες"}{" "}με το Primer AI</span>
                                </div>
                            ) : (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <IoCheckmarkDoneCircleSharp size={40} color="green" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>
                                        Όλες οι συναλλαγές είναι συγχρονισμένες με το Primer AI
                                    </span>
                                </div>
                            )}
                            <hr style={{marginTop: "0.3rem", marginBottom: "0.3rem"}} />
                            {syncData?.unsyncedEmployees > 0 ? (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <MdOutlineSyncProblem size={40} color="red" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>{syncData?.unsyncedEmployees}{" "}{syncData?.unsyncedEmployees === 1 ? "Εργαζόμενος δεν είναι συγχρονισμένος" : "Εργαζόμενοι δεν είναι συγχρονισμένοι"}{" "}με το Primer AI</span>
                                </div>
                            ) : (
                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                                    <IoCheckmarkDoneCircleSharp size={40} color="green" />
                                    <span style={{ fontWeight: "bold", textAlign: "center", flex: 1}}>
                                        Όλες οι εργαζόμενοι είναι συγχρονισμένοι με το Primer AI
                                    </span>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
                {!syncDataLoader && (
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            disabled={syncLoader}
                            onClick={() => syncBankDataNow()}>
                            {"Συγχρονισμός Τώρα "}
                            {syncLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
            <DemoVectorSearchModal show={showDemoVectorModal} setShow={setShowDemoVectorModal} />

            <Modal show={showResetAISettings} onHide={() => setShowResetAISettings(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Επαναφορά ρυθμίσεων AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να επαναφέρετε τις ρυθμίσεις AI;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowResetAISettings(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => saveSettings(true)} disabled={loadingSave}>
                        Επαναφορά
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showBuyCreditsModal}
                onHide={() => {
                    setShowBuyCreditsModal(false);
                    setIsCheckingOut(false);
                }}
                backdrop="static"
                className="themeModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isCheckingOut ? "Επιβεβαίωση Αγοράς AI Credits" : "Αγορά Πακέτου AI Credits"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isCheckingOut ? (
                        <Row>
                            <Col md={12}>
                                <p className="text-center font-weight-bold my-1">
                                    Αν έχετε ολοκληρώσει την αγορά μέσω της ιστοσελίδας μας,
                                    πατήστε το παρακάτω κουμπί για την ενημέρωση του συστήματος
                                </p>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col md={12} className="mb-3">
                                <p>Επιλέξτε το πακέτο των AI Credits που επιθυμείτε να προσθέσετε στην εταιρεία σας.</p>
                            </Col>
                            <Col md={12} className="mb-1">
                                <Dropdown
                                    name="creditPackages"
                                    label="Πακέτα AI Credits"
                                    options={creditPackagesOptions}
                                    defaultValue={creditPackagesOptions.find(o => o.value === selectedCreditAmount)}
                                    onChange={(e) => setSelectedCreditAmount(e.value)}
                                />
                            </Col>
                            {creditPackagePrices[selectedCreditAmount] !== undefined && (
                                <Col md={12}>
                                    <span className="mr-1" style={{ fontSize: "0.9rem" }}>
                                        Τιμή Συνδρομής:
                                    </span>
                                    <strong className={"text-primary"} style={{ fontSize: "1rem" }}>
                                        {getGreekCurrencyFormat(creditPackagePrices[selectedCreditAmount], 2)} τον μήνα
                                    </strong>
                                    <span className="ml-1" style={{ fontSize: "0.9rem" }}>με ετήσια χρέωση</span>
                                </Col>
                            )}
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-start">
                    {isCheckingOut ? (
                        <React.Fragment>
                            <Button
                                variant="primary"
                                className="ml-auto"
                                onClick={handleSyncOrderHistory}
                            >
                                Ενημέρωση Συστήματος
                                {syncOrderLoading && <Spinner className="ml-2" animation="border" variant="light" size="sm" />}
                            </Button>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Button
                                variant="primary"
                                className="ml-auto"
                                onClick={handleBuyCredits}
                                disabled={buyLoading}
                            >
                                Αγορά {buyLoading && <Spinner className="ml-2" animation="border" variant="light" size="sm" />}
                            </Button>
                        </React.Fragment>
                    )}
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default AISettings;
